import Card from '@perpay-web/components/base/Card/Card';
import ToggleSwitch from '@perpay-web/components/base/ToggleSwitch/ToggleSwitch';
import Inline from '@perpay-web/components/design-system/Inline/Inline';
import Stack from '@perpay-web/components/design-system/Stack/Stack';
import silverCard from '@perpay-web/fintech/assets/images/premiumSilver.png';
import { cardFees } from '@perpay-web/fintech/constants/cardFeesConstants';
import {
    SILVER_MATERIAL,
    PLASTIC_MATERIAL,
} from '@perpay-web/fintech/utils/cardAccountApplicationMetalUtils';
import { getClassName } from '@perpay-web/utils/domUtils';
import { formatCurrency } from '@perpay-web/utils/stringUtils';

import styles from './CardMaterialSelectionPremium.scss';

const metalCardProsList = [
    '18 grams of durable recycled steel',
    'Laser-engraved',
    'Tap to pay',
];

const CardMaterialSelectionPremium = ({
    onChange,
    value,
    onClickHeavyMetal,
    onClickLightPlastic,
}) => {
    const metalCardFee = formatCurrency(cardFees.METAL_CARD_FEE);

    const isMetalMaterial = value === SILVER_MATERIAL;

    const handleMaterialToggleChange = () => {
        if (!isMetalMaterial) {
            onChange(SILVER_MATERIAL);
            onClickHeavyMetal();
        } else {
            onChange(PLASTIC_MATERIAL);
            onClickLightPlastic();
        }
    };

    return (
        <Card className={styles.card}>
            <Stack className={styles.card__content}>
                <div className={styles['img-container']}>
                    <img
                        className={styles.img}
                        src={silverCard}
                        alt='premium_metal_card'
                    />
                </div>
                <div className={styles.list}>
                    <Stack className={styles.stack}>
                        {metalCardProsList.map((item) => (
                            <Inline key={item} className={styles.list__item}>
                                <div className={styles.list__icon} />
                                {item}
                            </Inline>
                        ))}
                    </Stack>
                </div>
                <Inline className={styles.option__wrapper}>
                    <Stack className={styles.option__left}>
                        <div className={styles.option__title}>Metal Card</div>
                        <div className={styles.option__description}>
                            Send me a metal card for a one-time $35 fee.
                        </div>
                    </Stack>
                    <Stack className={styles.option__right}>
                        <ToggleSwitch
                            checked={isMetalMaterial}
                            onChange={handleMaterialToggleChange}
                        />
                        <div
                            className={getClassName(
                                styles.option__fee,
                                !isMetalMaterial &&
                                    styles['option__fee--disabled'],
                            )}
                        >
                            +{metalCardFee}
                        </div>
                    </Stack>
                </Inline>
                <div className={styles.disclaimer}>
                    <strong>Free Plastic Card</strong> issued upon Metal Card
                    opt-out
                </div>
            </Stack>
        </Card>
    );
};

export default CardMaterialSelectionPremium;
